<template>
  <v-tooltip top :disabled="timeframe == ''" v-if="isAllTime">
    <template v-slot:activator="{ on, attrs }">
      <div
        :class="'d-flex ' + (alignEnd ? 'ml-2 align-end' : '')"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon :color="color" class="mr-2">{{ icon }}</v-icon>
        <span
          v-if="percent != null"
          :class="
            (ignoreMargin ? '' : 'my-auto') +
              (inherit ? '' : ' subtitle-1 secondarytext--text')
          "
        >
          {{ Math.abs(percent) | no_decimal }}%
        </span>
      </div>
    </template>
    <div class="tooltip-limit-width">Compared to {{ timeframe }}</div>
  </v-tooltip>
</template>

<script>
import moment from "moment";
import timeframes from "@/helpers/mixins/timeframes";
export default {
  name: "CompareText",
  mixins: [timeframes],
  props: {
    oldValue: { type: Number },
    newValue: { type: Number },
    inherit: { type: Boolean, default: false },
    ignoreMargin: { type: Boolean, default: false },
    alignEnd: { type: Boolean, default: false },
    timeframeId: { type: Number }
  },
  computed: {
    percent() {
      if (this.oldValue == null || this.newValue == null) {
        return null;
      }
      if (this.oldValue == 0) {
        return this.newValue != 0 ? 100 : 0;
      }
      let val =
        ((this.newValue - this.oldValue) / Math.abs(this.oldValue)) * 100;

      if (this.negative) {
        val = val * -1;
      }
      return val;
    },
    negative() {
      return this.newValue < 0;
    },
    color() {
      if (this.percent == null || this.percent == 0) {
        return "lighttext";
      }
      return this.percent > 0 ? "success" : "error";
    },
    icon() {
      if (this.percent == null || this.percent == 0) {
        return "remove";
      }
      return this.percent > 0 ? "trending_up" : "trending_down";
    },
    isAllTime() {
      return this.timeframeId != this.$enums.timeframes.ALL_TIME;
    },
    timeframe() {
      let months = this.getTimeframeMonths(this.timeframeId);
      if (months == 0) {
        return "";
      }

      let endDate = moment().subtract(months, "M");
      let startDate = moment().subtract(months * 2, "M");

      return `${startDate.format("MM/DD/YYYY")} - ${endDate.format(
        "MM/DD/YYYY"
      )}`;
    }
  }
};
</script>
